import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary fw-normal border border-lightgray border-top-0 border-start-0 border-end-0 pb-3 my-5" }, " Video: ", -1)

import { reactive } from "vue";
import BaseInputUnderline from "@/components/base-components/BaseInputUnderline.vue";


const __default__ = {
  name: "VideoStimuli",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let form = reactive({
  question: "",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(BaseInputUnderline, {
      class: "mt-5 col-12 col-sm-9 col-md-6",
      value: _unref(form).question,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).question) = $event)),
      name: "video-question",
      invalid: _unref(form).question,
      type: "text",
      id: "video-question",
      "aria-placeholder": "What do you think?",
      placeholder: "What do you think?",
      label: "Write a question"
    }, null, 8, ["value", "invalid"])
  ]))
}
}

})